import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
const EmptyRow = () => {
  return (
    <RowContainer>
      <UI.Icon name="addPerson" size={24} color="var(--alias-color-label-alternative)" />
      <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
        워크스페이스에 멤버를 초대해 보세요!
      </UI.Typography>
    </RowContainer>
  );
};

export default EmptyRow;

const RowContainer = styled.div`
  display: flex;
  gap: 8px;
  min-width: 832px;
  padding: 12px 24px;
  align-items: center;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;
